import { render, staticRenderFns } from "./ListaCadastros.vue?vue&type=template&id=2a0b6ed8&scoped=true&"
import script from "./ListaCadastros.vue?vue&type=script&lang=js&"
export * from "./ListaCadastros.vue?vue&type=script&lang=js&"
import style0 from "./ListaCadastros.vue?vue&type=style&index=0&id=2a0b6ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b6ed8",
  null
  
)

export default component.exports